var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50039 18.7096V15.043M1.29175 18.7096H18.7084M4.95842 6.44922V3.1263C4.95842 2.64007 5.15157 2.17376 5.49539 1.82994C5.8392 1.48612 6.30552 1.29297 6.79175 1.29297H15.0417V10.4023M11.3751 18.7096V12.293C11.3751 11.8067 11.5682 11.3404 11.9121 10.9966C12.2559 10.6528 12.7222 10.4596 13.2084 10.4596H17.7917V18.7096M2.20841 18.7096V8.6263C2.20841 8.14007 2.40157 7.67376 2.74539 7.32994C3.0892 6.98612 3.55552 6.79297 4.04175 6.79297H8.62508V18.7096H2.20841Z",
    stroke: "#08081B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.848fc5f9152a3fb8934beab626f6356c.svg";
export { ForwardRef as ReactComponent };